// extracted by mini-css-extract-plugin
module.exports = {"table":"SubmittedPreflightsTable-module__table___6P1b0","pagination":"SubmittedPreflightsTable-module__pagination___1dQ7R"};